import { Pipe, PipeTransform } from '@angular/core';
@Pipe({ name: 'onecase' })
export class OnecasePipe implements PipeTransform {
  transform(text: string): string {
    if (!text) return text;
    return `${text.substring(0, 1).toUpperCase()}${text.substring(1).toLowerCase()}`;
  }
}
